var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecrementArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55509 15.7078L12.5304 10.7128C12.9306 10.1965 12.5692 9.42209 11.9109 9.42209H10.5815C10.1556 9.42209 9.78126 9.13814 9.78126 8.71221L9.78126 0.774418C9.78126 0.348488 9.47149 0 9.03265 0L6.94172 0C6.5287 0 6.1673 0.348488 6.1673 0.774418L6.1673 8.71221C6.1673 9.13814 5.83159 9.42209 5.40579 9.42209H4.07638C3.43103 9.42209 3.06963 10.1965 3.46975 10.6999L7.34184 15.682C7.6387 16.095 8.24533 16.1079 8.55509 15.7078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrementArrow);
export default __webpack_public_path__ + "static/media/decrement-arrow.605159d8.svg";
export { ForwardRef as ReactComponent };